import React from 'react';

import { HeadlineTitle } from '../../components/Title';
import Steps from '../../components/Steps';
import { Col, Row } from '../../components/Grid';
import { SectionLayout } from '../../components/Layouts';
import { navRoutes } from '../../constants';
import Button from '../../components/Button';
import data from './data';

const HowItWorks = ({ page, title }) => {
  return (
    <SectionLayout id="how-it-works" bgcolor="gray2">
      <HeadlineTitle>{title || 'How Tempo Time Credits work'}</HeadlineTitle>
      <Row jc="center">
        <Col w={[4, 3, 4]} mt={4} mtM={3}>
          <Steps
            title={data[0].title[page]}
            description={data[0].description[page]}
            image={data[0].image}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4}>
          <Steps
            title={data[1].title[page]}
            description={data[1].description[page]}
            image={data[2].image}
            mt={4}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4}>
          <Steps
            title={data[2].title[page]}
            description={data[2].description[page]}
            image={data[1].image}
            mt={4}
          />
        </Col>
      </Row>
      {page !== 'FAQs' && (
        <Row jcT="center" mt={5}>
          <Col w={[4, 3, 4]}>
            <Button to={navRoutes.FAQs} color="blue" extraSmall>
              Read more
            </Button>
          </Col>
        </Row>
      )}
    </SectionLayout>
  );
};

export default HowItWorks;
